// GAVION deal value (owner ruling, MRR / ARR on the board): a deal with a « Forfait proposé » (76_) is worth its
// proposed MRR per month (fallback: its amount, already monthly); a deal without a package carries a hand-typed amount
// that is an annual value (ARR), so its MRR is the amount / 12. A hidden amount (72_) has no value for the viewer.
export type ValueDeal = {
  amount?: number | null;
  amount_hidden?: boolean | null;
  proposed_package_id?: unknown;
  proposed_mrr?: number | string | null;
};

const num = (v: number | string | null | undefined): number => {
  const n = Number(v ?? 0);
  return Number.isFinite(n) ? n : 0;
};

/** The deal's monthly recurring value, or null when its amount is hidden from the viewer (72_). */
export const dealMrr = (deal: ValueDeal): number | null => {
  if (deal.amount_hidden === true) return null;
  if (deal.proposed_package_id != null)
    return num(deal.proposed_mrr ?? deal.amount);
  return num(deal.amount) / 12;
};

/** The deal's annual value (package: MRR × 12; no package: the amount itself), or null when hidden (72_). */
export const dealArr = (deal: ValueDeal): number | null => {
  if (deal.amount_hidden === true) return null;
  if (deal.proposed_package_id != null) return (dealMrr(deal) ?? 0) * 12;
  return num(deal.amount);
};
